export default __webpack_public_path__ + "media/images/home/end-page-about.jpg";